/**
 * Report State Store
 * Manages report viewing state
 */

import { create } from 'zustand';

export type ClaimStatus = 'met' | 'partial' | 'not_met';

export interface ClaimFilter {
  status: ClaimStatus[];
  search: string;
}

export interface ReportState {
  filter: ClaimFilter;
  selectedClaimId: string | null;

  // Actions
  setStatusFilter: (status: ClaimStatus[]) => void;
  setSearch: (search: string) => void;
  setSelectedClaim: (id: string | null) => void;
  resetFilters: () => void;
}

const initialFilter: ClaimFilter = {
  status: [],
  search: '',
};

export const useReportStore = create<ReportState>((set) => ({
  filter: initialFilter,
  selectedClaimId: null,

  setStatusFilter: (status) =>
    set((state) => ({ filter: { ...state.filter, status } })),

  setSearch: (search) =>
    set((state) => ({ filter: { ...state.filter, search } })),

  setSelectedClaim: (selectedClaimId) => set({ selectedClaimId }),

  resetFilters: () => set({ filter: initialFilter }),
}));
